import { UPDATE_BREADCRUMB } from '#action/types';

export function updateBreadcrumb(data) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_BREADCRUMB,
      payload: data
    });
  };
}
